// src/services/towerSiteRAPService.js
import api from '../config/axios';

const BASE_PATH = '/tower-site-rap';

// ============= Query Operations =============

/**
 * Get all RAPs for a tower site (both SITAC and CME)
 */
export const getRAPsByTowerSiteId = async (towerSiteId) => {
  const timestamp = new Date().getTime();
  const response = await api.get(`${BASE_PATH}/tower-site/${towerSiteId}?_t=${timestamp}`);
  return response.data;
};

/**
 * Get RAPs by tower site and type (SITAC or CME)
 */
export const getRAPsByTowerSiteIdAndType = async (towerSiteId, rapType) => {
  const timestamp = new Date().getTime();
  const response = await api.get(
    `${BASE_PATH}/tower-site/${towerSiteId}/type/${rapType}?_t=${timestamp}`
  );
  return response.data;
};

/**
 * Get RAP by tower site, category, and type
 */
export const getRAPByTowerSiteAndCategoryAndType = async (towerSiteId, categoryId, rapType) => {
  const timestamp = new Date().getTime();
  const response = await api.get(
    `${BASE_PATH}/tower-site/${towerSiteId}/category/${categoryId}/type/${rapType}?_t=${timestamp}`
  );
  return response.data;
};

/**
 * Get RAP by ID
 */
export const getRAPById = async (id) => {
  const response = await api.get(`${BASE_PATH}/${id}`);
  return response.data;
};

/**
 * Check if RAP exists for tower site, category, and type
 */
export const checkRAPExists = async (towerSiteId, categoryId, rapType) => {
  const response = await api.get(
    `${BASE_PATH}/tower-site/${towerSiteId}/category/${categoryId}/type/${rapType}/exists`
  );
  return response.data.exists;
};

// ============= Command Operations =============

/**
 * Create or Update RAP
 */
export const saveRAP = async (rapData) => {
  const response = await api.post(BASE_PATH, rapData);
  return response.data;
};

/**
 * Delete RAP
 */
export const deleteRAP = async (id) => {
  await api.delete(`${BASE_PATH}/${id}`);
};

/**
 * Approve RAP
 */
export const approveRAP = async (id, approverName = 'System') => {
  const response = await api.post(`${BASE_PATH}/${id}/approve`, {
    approverName
  });
  return response.data;
};

/**
 * Unapprove RAP
 */
export const unapproveRAP = async (id) => {
  const response = await api.post(`${BASE_PATH}/${id}/unapprove`);
  return response.data;
};

// ============= Export Default =============

const towerSiteRAPService = {
  getRAPsByTowerSiteId,
  getRAPsByTowerSiteIdAndType,
  getRAPByTowerSiteAndCategoryAndType,
  getRAPById,
  checkRAPExists,
  saveRAP,
  deleteRAP,
  approveRAP,
  unapproveRAP
};

export default towerSiteRAPService;
